import { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { CarregarPermissoes, ValidarPermissao } from '@/modules/system/auth/application/auth.service';
import { RoleEnum } from '@/modules/system/auth/domain/enums/role.enum';
import { PermissionEnum } from '@/modules/system/auth/domain/enums/permission.enum';
import { ListAllIntershipsOfTheMonthResponseDto } from '@/api.types';
import { listEstagiarioAttendanceSheets } from '@/modules/business/attendance-sheet/attendance-sheet.service';

export function useEstagiarioFolhasPerfil(estagiarioId?: number, ativo = false) {
  const [carregando, setCarregando] = useState(false);
  const [folhas, setFolhas] = useState<ListAllIntershipsOfTheMonthResponseDto[]>([]);

  const permissoes = useMemo(() => CarregarPermissoes(), []);
  const permissaoExcluirFolhas = ValidarPermissao(permissoes, [
    { role: RoleEnum.FOLHA, level: PermissionEnum.DELETE },
  ]);

  const recarregar = useCallback(() => {
    if (!estagiarioId) {
      setFolhas([]);
      return;
    }

    setCarregando(true);
    listEstagiarioAttendanceSheets(estagiarioId)
      .then(setFolhas)
      .catch((e) => toast.error(String(e)))
      .finally(() => setCarregando(false));
  }, [estagiarioId]);

  useEffect(() => {
    if (!ativo || !estagiarioId) return;
    recarregar();
  }, [ativo, estagiarioId, recarregar]);

  return {
    folhas,
    carregando,
    recarregar,
    permissaoExcluirFolhas,
  };
}
